import { CdkDrag, CdkDragDrop, CdkDropList, moveItemInArray } from "@angular/cdk/drag-drop";
import {
    ChangeDetectionStrategy,
    Component,
    inject,
    OnDestroy,
    OnInit,
    ViewChild
} from "@angular/core";
import { NgbActiveModal, NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { from } from "rxjs";
import { BusyService } from "~app/common/components/busy/busy.service";
import { Barighetsklasser, ConfirmDialogResponse, TplMapLayerConstats } from "~app/common/models/constants";
import { CommandService } from "~app/common/services/cqs/command.service";
import { CommandManager, ICommandManager } from "~app/common/services/cqs/commandManager";
import { EventService } from "~app/common/services/cqs/event.service";
import { DirtyFormService, IDirtyFormResult } from "~app/common/services/dirty-form.service";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { AddArbetsorderIntressentCommand } from "~app/features/planera/commands/AddArbetsorderIntressentCommand";
import {
    MassUpdateViapunkterCommand,
    MoveArbetsorderStartpunktCommand,
    SetJusteratAvstandCommand,
    SetTillaggsavstandStorstaAvlaggCommand,
    UpdateArbetsorderTransportavstandGeometryCommand,
    UpdateViapunkterCommand
} from "../../models/commands";
import { ITplJusteraruttArbetsorder } from "../../models/dtos";
import {
    IArbetsorderTransportavtand,
    IGeolocationDto,
    ITplDestineringRuttQueryResult,
    ITplKvvNyRuttQueryResult,
    TplDestineringRuttQuery,
    TplKvvNyRuttBkDataQuery,
    TplKvvNyRuttQuery
} from "../../models/queries";
import { TplService } from "../../services/tpl.service";

import { FormsModule } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { CardComponent } from "@components/cards/card/card.component";
import { CardsComponent } from "@components/cards/cards.component";
import { InfoComponent } from "@components/info/info.component";
import { InputNumberComponent } from "@components/input-number/input-number.component";
import { LabelComponent } from "@components/label/label.component";
import { SelectorComponent } from "@components/selector/selector.component";
import { SpanComponent } from "@components/span/span.component";
import { TabComponent } from "@components/tabs/tab/tab.component";
import { TabsComponent } from "@components/tabs/tabs.component";
import { orderBy, uniq, uniqWith } from "lodash";
import { ModalSettings } from "~app/common/components/modal/modal-models";
import { RaskModalService } from "~app/common/components/modal/rask-modal.service";
import { RadiobuttonGroupComponent } from "~app/common/components/radiobuttongroup/radiobuttongroup.component";
import { SetArbetsorderVerkligaAvlaggCommand } from "~app/features/planera/commands/SetArbetsorderVerkligaAvlaggCommand";
import { DecimalPipe } from "../../../../../common/pipes/decimal.pipe";
import { KilometerPipe } from "../../../../../common/pipes/kilometer.pipe";
import { ValidationMessageRowComponent } from "../../../../../common/validation/validation-message-row/validation-message-row.component";
import {
    AnvandVerkligaAvlaggChangedEvent,
    DeleteViapunktEvent,
    PointLocationChangedEvent,
    RuttChangedEvent,
    StartpunktResetEvent,
    ToggleViapunktReadonlyEvent,
    TplTransportAvstandEventHandler
} from "./tpl-transportavstand-eventhandler";
import { TplTransportavstandKartaComponent } from "./tpl-transportavstand-karta/tpl-transportavstand-karta.component";
import { TplTransportavstandWarningComponent } from "./tpl-transportavstand-warning/tpl-transportavstand-warning.component";
@Component({
    selector: "rask-tpl-transportavstand-modal",
    templateUrl: "./tpl-transportavstand-modal.component.html",
    styleUrls: ["./tpl-transportavstand-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CardsComponent,
        CardComponent,
        LabelComponent,
        SpanComponent,
        SelectorComponent,
        FormsModule,
        ButtonComponent,
        InputNumberComponent,
        TabsComponent,
        TabComponent,
        ValidationMessageRowComponent,
        InfoComponent,
        CdkDropList,
        CdkDrag,
        TplTransportavstandKartaComponent,
        KilometerPipe,
        DecimalPipe,
        RadiobuttonGroupComponent
    ]
})
export class TplTransportavstandModalComponent implements OnInit, OnDestroy {
    readonly dirtyFormService = inject(DirtyFormService);
    readonly activeModal = inject(NgbActiveModal);

    @ViewChild("tillaggsavstand") tillaggsavstandInput: InputNumberComponent;

    arbetsorder: ITplJusteraruttArbetsorder;
    handelssortimentId: number;
    mottagningsplatsId: number;
    context: "transportplanera" | "planera";

    destinationData: ITplDestineringRuttQueryResult;

    vagmotstand: number;
    barighetsklass: string;
    tillaggsavstandStorstaAvlagg: number;
    radioButtonValAvBk = [
        {
            key: Barighetsklasser.BK1,
            value: "BK 1"
        },
        {
            key: Barighetsklasser.BK4,
            value: "BK 4"
        }
    ];

    vagmotstandValues: any[] = [
        {
            text: "Sommar",
            value: 1
        },
        {
            text: "Vinter",
            value: 2
        }
    ];

    protected barighetsklasser: string[] = [];
    protected activeTransportAvstand: IArbetsorderTransportavtand;

    private readonly tplService = inject(TplService);
    private readonly eventService = inject(EventService);
    private readonly busyService = inject(BusyService);
    private readonly commandService = inject(CommandService);
    private readonly modalService = inject(NgbModal);
    private readonly raskModalService = inject(RaskModalService);
    private readonly eventHandler: TplTransportAvstandEventHandler;
    private readonly commandManager: ICommandManager;
    constructor() {

        this.commandService = this.commandService.createInstance();
        this.eventHandler = new TplTransportAvstandEventHandler(this.eventService);
        this.commandManager = new CommandManager();
    }

    static open(
        arbetsorder: ITplJusteraruttArbetsorder,
        handelssortimentId: number,
        mottagningsplatsId: number,
        backdrop: "standard" | false,
        context: "transportplanera" | "planera",
        modalService: NgbModal,
        callBack: (result: any) => void = null) {
        const options = {
            keyboard: false,
            backdrop: backdrop,
            centered: true,
            windowClass: "transportavstand-modal-size"
        } as NgbModalOptions;
        const modalRef = modalService.open(this, options);
        modalRef.componentInstance.arbetsorder = arbetsorder;
        modalRef.componentInstance.handelssortimentId = handelssortimentId;
        modalRef.componentInstance.mottagningsplatsId = mottagningsplatsId;
        modalRef.componentInstance.context = context;

        if (callBack) {
            modalRef.result.then(r => callBack(r));
        } else {
            modalRef.result.then(r => modalRef.close(r));
        }
    }

    motstandViewFormatter = (item: any) => item.text;
    motstandFormatter = (result: any) => result ? result.value : undefined;

    ngOnInit(): void {
        this.initModal();

        this.eventHandler.onViapunktDeleted(e => {
            this.updateBkViapunkter();
        });

        this.eventHandler.onViapunktModified(e => {
            if (e.uppdateraAllaMottagningsplatser) {
                this.massUpdateBkViapunkter();
            } else {
                this.updateBkViapunkter();
            }
        });

        this.eventHandler.onPointLocationChanged(e => this.onPointChanged(e));

        this.dirtyFormService.ignoreRoutes = [
            "planera",
            "transportplanera"
        ];
        this.dirtyFormService.onDirtyNgModel(
            this.isModelDirty.bind(this),
            null,
            d => this.dirtyCheckCallback(d),
            null,
            "Du har gjort ändringar i rutten",
            "Vill du lämna utan att beräkna ny rutt?",
            null);
    }
    onMapReady() {
        const event = new ToggleViapunktReadonlyEvent(this.arbetsorder.anvandVerkligaAvlagg);
        this.eventService.emit(event);
    }

    ngOnDestroy(): void {
        this.eventHandler.unsubscribe();
    }

    initModal() {
        const query = new TplDestineringRuttQuery(this.arbetsorder.id, this.handelssortimentId, this.mottagningsplatsId);

        this.tplService.getRutt(query).subscribe((data: ITplDestineringRuttQueryResult) => {
            this.destinationData = data;
            this.activeTransportAvstand = data.arbetsorderTransportavtand[0];
            this.barighetsklasser = uniq(orderBy(data.arbetsorderTransportavtand.map(a => a.barighetsklass), (obj) => obj, "asc"));
            const vagmotstand = uniq(data.arbetsorderTransportavtand.map(a => a.vagmotstand));
            this.vagmotstandValues = this.vagmotstandValues.filter(v => vagmotstand.includes(v.value));
            this.initPage();
        });
    }

    checkActiveArbetsorderTransportavstand() {
        this.destinationData.arbetsorderTransportavtand.forEach(x => {
            x.active = x.vagmotstand === this.vagmotstand &&
                x.barighetsklass === this.barighetsklass;
            if (x.active) {
                this.activeTransportAvstand = x;
            }
        });
        const event = new RuttChangedEvent(this.arbetsorder.id);
        this.eventService.emit(event);
    }

    initPage() {
        if (!this.destinationData.arbetsorderTransportavtand.some(x => x.barighetsklass === Barighetsklasser.BK1)) {
            this.addDefaultArbetsorderTransportavstand(Barighetsklasser.BK1);
        }
        if (!this.destinationData.arbetsorderTransportavtand.some(x => x.barighetsklass === Barighetsklasser.BK4)) {
            this.addDefaultArbetsorderTransportavstand(Barighetsklasser.BK4);
        }
        this.destinationData.arbetsorderTransportavtand[0].active = true;
        this.vagmotstand = this.destinationData.arbetsorderTransportavtand[0].vagmotstand;

        this.tillaggsavstandStorstaAvlagg = this.destinationData.tillaggsavstandStorstaAvlagg;

        this.destinationData.arbetsorderTransportavtand.forEach(x => {
            if (x.viaPunkter === null) {
                x.viaPunkter = [];
            }
            let index = 1;
            x.viaPunkter.forEach(vp => {
                vp.index = index;
                index++;
            });
        });
    }

    dropViapunkt(event: CdkDragDrop<IGeolocationDto[]>) {
        const activeBkKlass = this.destinationData.arbetsorderTransportavtand.find(x => x.active);
        moveItemInArray(activeBkKlass.viaPunkter, event.previousIndex, event.currentIndex);
        this.updateBkViapunkter();
    }

    tryClose() {
        if (!this.commandManager.isDirty() || this.dirtyFormService.canClose()) {
            this.close();
        }
    }

    close() {
        this.activeModal.close();
    }

    canCalculate(): boolean {
        return !ObjectUtils.isNullOrUndefined(this.destinationData?.startPunkt?.easting) && !ObjectUtils.isNullOrUndefined(this.destinationData?.startPunkt?.northing);
    }

    canSave(): boolean {
        return this.commandManager.isDirty();
    }

    save() {
        const movestartPunkt = this.commandManager.getStack().find(x => x.$type === MoveArbetsorderStartpunktCommand.$type);
        if (movestartPunkt) {
            const messageHeader = "Ändringar sker för hela arbetsordern";
            const message = "Startpunkten kommer att ändras för samtliga handelssortiment på arbetsordern";

            TplTransportavstandWarningComponent.open(messageHeader, message, this.modalService, (res: boolean) => {
                if (res) {
                    this.doSave();
                }
            });
        } else {
            this.doSave();
        }
    }

    beraknaRutt() {
        if (!this.canCalculate) {
            return;
        }

        const query = new TplKvvNyRuttQuery(
            this.destinationData.startPunkt,
            this.arbetsorder.id,
            this.mottagningsplatsId,
            this.destinationData.arbetsorderTransportavtand.map(x => new TplKvvNyRuttBkDataQuery(x.viaPunkter, x.barighetsklass)),
            this.vagmotstand ?? 1);
        const work = this.tplService.loadNyRuttGeometry(query);
        this.busyService
            .addWork(work)
            .subscribe((response) => {
                if (response) {
                    this.setNewRoute(response);
                }
            });

    }

    resetStartpunkt() {
        this.destinationData.startPunkt = this.destinationData.defaultStartPunkt;
        this.destinationData.startpunktJusterad = false;
        this.commandManager.addOrUpdate(new MoveArbetsorderStartpunktCommand(
            this.arbetsorder.id,
            null), c => c.$type === MoveArbetsorderStartpunktCommand.$type);
        const event = new StartpunktResetEvent(this.destinationData.startPunkt.easting, this.destinationData.startPunkt.northing);
        this.eventService.emit(event);
        this.beraknaRutt();
    }

    deleteViapunkt(arbetsordertransportavstand: IArbetsorderTransportavtand, easting: number, northing: number) {
        const index = arbetsordertransportavstand.viaPunkter.findIndex(x => x.easting === easting && x.northing === northing);
        if (index > -1) {
            arbetsordertransportavstand.viaPunkter.splice(index, 1);
            this.updateBkViapunkter();
            const event = new DeleteViapunktEvent({
                easting: easting,
                northing: northing
            });
            this.eventService.emit(event);
        }
    }

    deleteAllViapunkter() {
        this.destinationData.arbetsorderTransportavtand.forEach(x => x.viaPunkter = []);
        this.updateBkViapunkter(false);
    }

    dirtyCheckCallback(result: IDirtyFormResult) {
        if (result.isSkipSave) {
            // close and dismiss
            this.commandService.reset();
            this.close();
        } else if (result.isCancel) {
            // do nothing
        } else {
            // save (Används ej här)
        }
    }

    onExtraKmChange(bkdata: IArbetsorderTransportavtand) {
        this.commandManager.addOrUpdate(new SetJusteratAvstandCommand(
            this.arbetsorder.id,
            this.mottagningsplatsId,
            bkdata.barighetsklass,
            bkdata.extraKm), c => c.$type === SetJusteratAvstandCommand.$type &&
                c.arbetsorderId === this.arbetsorder.id &&
                c.mottagningsplatsId === this.mottagningsplatsId &&
                c.barighetsklass === bkdata.barighetsklass &&
                c.krontVagvalMotstand === bkdata.vagmotstand);
    }

    onTillaggsavstandStorstaAvlaggChange() {
        this.commandManager.addOrUpdate(new SetTillaggsavstandStorstaAvlaggCommand(
            this.arbetsorder.id,
            this.tillaggsavstandStorstaAvlagg), c => c.$type === SetTillaggsavstandStorstaAvlaggCommand.$type);
    }

    isModelDirty() {
        return this.commandManager.isDirty();
    }

    getTabLabel(bkklass: string) {
        const transportavstand = this.destinationData.arbetsorderTransportavtand
            .find(x => x.vagmotstand === this.vagmotstand &&
                x.barighetsklass === bkklass);

        return `${bkklass} (${transportavstand?.krontVagvalKm ?? 0})`;
    }

    getIconColor(barighetsklass: string) {
        if (barighetsklass === Barighetsklasser.BK4) {
            return TplMapLayerConstats.bk4PrimaryRouteColor;
        }
        return TplMapLayerConstats.bk1PrimaryRouteColor;
    }

    setActiveBkTab(barighetsklass: string) {
        this.barighetsklass = barighetsklass;
        this.checkActiveArbetsorderTransportavstand();
    }

    verkligaAvlaggCheckedChanged(value: boolean): void {
        const cmd = new SetArbetsorderVerkligaAvlaggCommand((instance) => {
            instance.arbetsorderId = this.arbetsorder.id;
            instance.anvandVerkligaAvlagg = value;
        });
        this.commandManager.addOrUpdate(cmd, (c) => c.$type === SetArbetsorderVerkligaAvlaggCommand.$type && c.arbetsorderId === this.arbetsorder.id);
        const event = new ToggleViapunktReadonlyEvent(value);
        this.eventService.emit(event);

    }
    private doSave() {
        if (this.arbetsorder.anvandVerkligaAvlagg && this.hasViapunktOrTillagg()) {
            const settings = new ModalSettings("Verkliga avlägg", "Verkliga avlägg i Prolog kan inte användas för att beräkna avstånd till industri i kombination med viapunkter eller tilläggsavstånd på arbetsordern.");
            settings.noCaption = "Använd verkliga avlägg";
            settings.yesCaption = "Använd startpunkt";
            this.raskModalService.confirm(settings).subscribe(x => {
                if (x === ConfirmDialogResponse.cancel) {
                    this.tillaggsavstandStorstaAvlagg = null;
                    this.onTillaggsavstandStorstaAvlaggChange();
                    this.deleteAllViapunkter();

                    const query = new TplKvvNyRuttQuery(
                        this.destinationData.startPunkt,
                        this.arbetsorder.id,
                        this.mottagningsplatsId,
                        this.destinationData.arbetsorderTransportavtand.map(x => new TplKvvNyRuttBkDataQuery(x.viaPunkter, x.barighetsklass)),
                        this.vagmotstand ?? 1);
                    this.tplService.loadNyRuttGeometry(query).subscribe(x => {
                        this.setNewRoute(x);
                        this.saveData();
                    });
                } else {
                    this.arbetsorder.anvandVerkligaAvlagg = false;
                    this.verkligaAvlaggCheckedChanged(false);
                    this.saveData();
                }
            });
        } else {
            this.saveData();
        }
    }

    private hasViapunktOrTillagg() {
        return this.tillaggsavstandStorstaAvlagg || this.destinationData.arbetsorderTransportavtand.some(x => x.viaPunkter.length > 0);
    }

    private saveData() {
        if (this.context === "transportplanera") {
            const cmd = new AddArbetsorderIntressentCommand((instance) => {
                instance.arbetsorderId = this.arbetsorder.id;
            });
            this.commandManager.addOrUpdate(cmd, c => c.$type === AddArbetsorderIntressentCommand.$type);
        }

        const work = from(this.commandService.pushCommands(this.commandManager));
        this.busyService.addWork(work)
            .subscribe((response) => {
                if (response) {
                    const event = new RuttChangedEvent(this.arbetsorder.id);
                    this.eventService.emit(event);

                    this.checkAnvandVerkligaAvlaggChanged();
                }
                this.commandManager.clear();
            });
    }

    private checkAnvandVerkligaAvlaggChanged() {
        const anvandVerkligaAvlagg = this.commandManager.getStack().find(x => x.$type === SetArbetsorderVerkligaAvlaggCommand.$type);
        if (anvandVerkligaAvlagg) {
            const eventChange = new AnvandVerkligaAvlaggChangedEvent(this.arbetsorder.id, this.arbetsorder.anvandVerkligaAvlagg);
            this.eventService.emit(eventChange);
        }
    }

    private onPointChanged(e: PointLocationChangedEvent) {

        const newPoint = this.getPoint(e.geometry);

        if (e.geometryBeforeChange.id === "startpunkt") {
            this.moveStartpunkt(newPoint);
        } else {
            this.moveViapunkt(e, newPoint);
        }
    }

    private setNewRoute(routeData: ITplKvvNyRuttQueryResult) {
        this.destinationData.arbetsorderTransportavtand.forEach(x => {
            const kvvData = routeData.krontvagvalResponseData.find(y => y.barighetsklass === x.barighetsklass);
            if (kvvData) {
                x.krontVagvalKm = kvvData.krontVagvalKm;
                x.routeGeometry = kvvData.routeGeometry;
                x.felmeddelande = kvvData.felmeddelande;
                x.felmeddelandekod = kvvData.felmeddelandekod;
                x.berakningstid = kvvData.berakningstid;

                const command = new UpdateArbetsorderTransportavstandGeometryCommand((c) => {
                    c.arbetsorderId = this.arbetsorder.id;
                    c.mottagningsplatsId = this.mottagningsplatsId;
                    c.barighetsklass = x.barighetsklass;
                    c.routeGeometry = x.routeGeometry;
                    c.felmeddelandekod = x.felmeddelandekod;
                    c.vagmotstand = x.vagmotstand;
                    c.krontVagvalKm = x.krontVagvalKm;
                    c.berakningstid = x.berakningstid;
                });

                this.commandManager.addOrUpdate(command, c => c.$type === UpdateArbetsorderTransportavstandGeometryCommand.$type &&
                    c.arbetsorderId === this.arbetsorder.id &&
                    c.mottagningsplatsId === this.mottagningsplatsId &&
                    c.barighetsklass === x.barighetsklass &&
                    c.vagmotstand === x.vagmotstand);
            }
        });

        const event = new RuttChangedEvent(this.arbetsorder.id);
        this.eventService.emit(event);
    }

    private getPoint(geometry: any): IGeolocationDto {
        const wkt = geometry.wkt;
        if (!ObjectUtils.hasValue(wkt)) {
            return null;
        }

        const points = wkt.split("(")[1].split(")")[0].split(" ");
        return {
            easting: points[0],
            northing: points[1]
        };
    }

    private moveStartpunkt(point: IGeolocationDto) {
        this.destinationData.startPunkt = point;
        this.destinationData.startpunktJusterad = true;
        this.commandManager.addOrUpdate(new MoveArbetsorderStartpunktCommand(
            this.arbetsorder.id,
            point), c => c.$type === MoveArbetsorderStartpunktCommand.$type);
        this.beraknaRutt();
    }

    private updateBkViapunkter(beraknaRutt = true) {
        this.destinationData.arbetsorderTransportavtand.forEach(x => {
            this.commandManager.addOrUpdate(new UpdateViapunkterCommand(
                this.arbetsorder.id,
                this.mottagningsplatsId,
                x.barighetsklass,
                x.vagmotstand,
                x.viaPunkter
            ), c => c.$type === UpdateViapunkterCommand.$type &&
                c.arbetsorderId === this.arbetsorder.id &&
                c.mottagningsplatsId === this.mottagningsplatsId &&
                c.barighetsklass === x.barighetsklass &&
                c.vagmotstand === x.vagmotstand
            );
        });
        if(beraknaRutt) {
            this.beraknaRutt();
        }
    }

    private massUpdateBkViapunkter() {
        const viapunkter = this.destinationData.arbetsorderTransportavtand
            .flatMap(aot => aot.viaPunkter)
            .filter(aot => ObjectUtils.hasValue(aot.barighetsklasser));

        const uniqueViapunkter = uniqWith(viapunkter, (a, b) => a.easting === b.easting && a.northing === b.northing);

        if (uniqueViapunkter.length === 0) {
            console.error("Kan inte massuppdatera med 0 viapunkter");
            return;
        }

        this.commandManager.addOrUpdate(new MassUpdateViapunkterCommand(
            this.arbetsorder.id,
            uniqueViapunkter
        ), c => c.$type === MassUpdateViapunkterCommand.$type &&
            c.arbetsorderId === this.arbetsorder.id
        );

        this.beraknaRutt();
    }

    private moveViapunkt(event: PointLocationChangedEvent, newPoint: IGeolocationDto) {
        const activeBkKlass = this.destinationData.arbetsorderTransportavtand.find(x => x.active);
        const point = activeBkKlass.viaPunkter.find(x => x.easting === event.geometryBeforeChange.easting && x.northing === event.geometryBeforeChange.northing);

        if (ObjectUtils.hasValue(point)) {
            point.easting = newPoint.easting;
            point.northing = newPoint.northing;
        }
        this.updateBkViapunkter();
    }

    private addDefaultArbetsorderTransportavstand(barighetsklass: string) {
        this.destinationData.arbetsorderTransportavtand.push({
            barighetsklass: barighetsklass,
            active: false,
            extraKm: undefined,
            krontVagvalKm: undefined,
            vagmotstand: 1,
            viaPunkter: [],
            routeGeometry: undefined,
            felmeddelande: undefined,
            felmeddelandekod: undefined,
            id: undefined
        });
    }
}
